// extracted by mini-css-extract-plugin
export var loginBtn = "DesktopNav-module--loginBtn--50448";
export var mainNavItem = "DesktopNav-module--mainNavItem--c729f";
export var mainNavList = "DesktopNav-module--mainNavList--4947e";
export var nav = "DesktopNav-module--nav--da25c";
export var routing = "DesktopNav-module--routing--705e4";
export var secondaryNav = "DesktopNav-module--secondaryNav--0f365";
export var secondaryNavContainer = "DesktopNav-module--secondaryNavContainer--e43f6";
export var secondaryNavItem = "DesktopNav-module--secondaryNavItem--4d0db";
export var secondaryNavList = "DesktopNav-module--secondaryNavList--adc36";
export var subNavList = "DesktopNav-module--subNavList--a2265";
export var tertiaryNavItem = "DesktopNav-module--tertiaryNavItem--f5cd5";
export var tertiaryNavList = "DesktopNav-module--tertiaryNavList--6e288";